<template>
  <div class="w-100 h-100  google-map__wrap">
    <section class="google-map">
    <transition name="fade" mode="out-in">
      <div v-if="tollTipShow" @click="tollTipShow = false" class="google-map__text-wrap">
        <div class="google-map__text-inner-wrap">
          <div class="google-map__text" v-html="toolTip"></div>
          <svg class="google-map__close">
            <use xlink:href="#icon-times-light"></use>
          </svg>
        </div>
      </div>
    </transition> 
    <div ref="mapDiv" class="w-100 h-100"></div>
  </section>
  <transition name="slide-up-fade" mode="out-in">
      <LoaderComponent v-if="loading && showCatMap" />
    </transition>
  </div>
</template>

<script setup lang="ts">
import { computed, ComputedRef, onMounted, Ref, ref } from "vue";
import { useProductStore } from "../../store/product.ts";
import { storeToRefs } from "pinia";
import { useMapStore } from "../../store/map.ts";
import { useCategoryStore } from "../../store/category.ts";
import { useGetCategory } from "../../composables/getCategory";
import LoaderComponent from "../../components/category-page/LoaderComponent.vue";

const productStore = useProductStore();
const { setRequest } = productStore;
const { prodRequest } = storeToRefs(productStore);
const { setIsMapOpen } = useMapStore();
const { setName } = useCategoryStore();
const showCatMap = (window as any).showCatMap as boolean;
const { getCategory, setValues, loading, searchPage } = useGetCategory();

const toolTip: ComputedRef<string> = computed(() => {
  return (window as any).mapTollTip;
});

const tollTipShow: Ref<boolean> = ref(true);
const mapDiv: Ref<HTMLElement | null> = ref(null);
const places: Ref<google.maps.Geocoder> = ref(new google.maps.Geocoder());

async function setMap() {
  if (!mapDiv.value) return;
  let markers: google.maps.Marker[] = [];

  const { Map } = (await google.maps.importLibrary("maps")) as google.maps.MapsLibrary;
  const googleMap = new Map(mapDiv.value, {
    center: {
      lat: prodRequest.value.lat,
      lng: prodRequest.value.lng,
    },
    mapTypeId: google.maps.MapTypeId.SATELLITE,
    streetViewControl: false,
    zoom: 15,
    draggableCursor: "pointer",
    draggingCursor: "pointer",
  });
  setMarker(prodRequest.value.lat, prodRequest.value.lng);
  setCords();

  function setMarker(lat:number, lng: number) {
    markers.forEach((marker) => marker.setMap(null));
    markers = [];

    const latLng = new google.maps.LatLng(lat, lng);
    const newMarker = new google.maps.Marker({
      position: latLng,
      map: googleMap,
    });
    markers.push(newMarker);
  }

  function setCords() {
    googleMap.addListener("click", async (e) => {
    
     await  places.value.geocode(
        {
          latLng: e.latLng,
        },
        (results, status) => {       
          if (status == google.maps.GeocoderStatus.OK) {
            
            if (results && results[0]) {
              setName(results[0].formatted_address);
              const names = results[0].address_components?.map((item) => item.short_name) || [];
           
             setValues(results[0].formatted_address , names, e.latLng.lng(),  e.latLng.lat())
            }
          }
        }
      );
      setMarker(e.latLng.lat(), e.latLng.lng());
      if(!showCatMap){
        setRequest({ ...prodRequest.value, lat: e.latLng.lat(), lng: e.latLng.lng() });
      }else{           
        getCategory()
      }  
      closeMap();
    });
  }
}

function closeMap() {
  if (window.innerWidth < 1200) {
    const header = document.getElementById("header");
    const navSearch = document.getElementById("navSearch");
    document.body.classList.remove("map-opend");
    header?.classList.remove("top");
    navSearch?.classList.remove("top");
    setIsMapOpen(false);
  }
}

onMounted(() => {
  setMap();
});
</script>
